import userStorage from 'src/modules/authentication/storage/user/storage';
import NodeUserInfoAPIs from '../../db/node-user-info';
export const epQuestionMutations = {
    async ep_updateQuestionRead(_, { id, read }) {
        const userID = userStorage.getUserDetails().id;
        if (!userID)
            return false;
        console.log('Updating question read status:', { id, read });
        try {
            await NodeUserInfoAPIs.updateUserData(userID, id, 'read', read);
            return true;
        }
        catch (error) {
            console.error('Error updating question read status:', error);
            return false;
        }
    },
    async ep_updateQuestionBookmark(_, { id, bookmark }) {
        const userID = userStorage.getUserDetails().id;
        if (!userID)
            return false;
        console.log('Updating question bookmark status:', { id, bookmark });
        try {
            await NodeUserInfoAPIs.updateUserData(userID, id, 'bookmarked', bookmark);
            return true;
        }
        catch (error) {
            console.error('Error updating question bookmark status:', error);
            return false;
        }
    },
};
